import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';

interface FormValues {
  type: string;
}

const Disabled: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);

  // Verifica se o contexto está definido
  if (!context) {
    throw new Error('Step1 must be used within an AppProvider');
  }

  const { appData, updateAppData } = context;

  return (
    <div className="content" style={{ minHeight: 'auto' }}>
      <div className="mx-auto max-w-2xl lg:text-center">
        <p className="color-primary mt-20 text-4xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-5xl lg:text-balance">Personalizador de App Desativado</p>
        <p className="mt-10 font-semibold tracking-tight text-pretty text-gray-900 sm:text-2xl lg:text-balance">O personalizador de app no momento está desativado para seu serviço.</p>
        <p className="mt-10 mb-20 text-lg/8 text-gray-600">Entre em contato com nosso suporte caso tenha alguma dúvida</p>
      </div>
    </div>
  );
};

export default Disabled;